// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Usage Page Styles */
.usage-page {
    padding: 20px;
}

.page-title {
    display: flex;
    align-items: center;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 0;
}

/* Trial Alert */
.trial-alert {
    border-left: 4px solid #28a745;
    background-color: #d4edda;
    border-radius: 8px;
}

.trial-alert h5 {
    color: #155724;
    margin-bottom: 0.5rem;
}

.trial-alert p {
    color: #155724;
    font-size: 0.95rem;
}

/* Stat Cards */
.stat-card {
    border: none;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: transform 0.2s, box-shadow 0.2s;
    height: 100%;
}

.stat-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.stat-card .card-body {
    padding: 1.5rem;
    display: flex;
    align-items: center;
    gap: 1rem;
}

.stat-icon {
    width: 60px;
    height: 60px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.stat-icon.trips {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
}

.stat-icon.amount {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    color: white;
}

.stat-icon.price {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    color: white;
}

.stat-icon.status {
    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
    color: white;
}

.stat-content {
    flex: 1 1;
}

.stat-label {
    font-size: 0.85rem;
    color: #6c757d;
    margin-bottom: 0.5rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.stat-value {
    font-size: 1.8rem;
    font-weight: 700;
    color: #2c3e50;
    margin: 0;
    line-height: 1;
}

/* Billing Detail Items */
.billing-detail-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 0;
}

.billing-detail-item .label {
    color: #6c757d;
    font-weight: 500;
}

.billing-detail-item .value {
    color: #2c3e50;
    font-weight: 600;
}

.billing-detail-item.total {
    padding-top: 1rem;
    border-top: 2px solid #dee2e6;
}

.billing-detail-item.total .label {
    color: #2c3e50;
    font-size: 1.1rem;
}

.billing-detail-item.total .value {
    color: #2962ff;
    font-size: 1.2rem;
}

/* Cards */
.usage-page .card {
    border: none;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    margin-bottom: 1.5rem;
}

.usage-page .card-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 12px 12px 0 0 !important;
    padding: 1rem 1.5rem;
}

.usage-page .card-header h5 {
    display: flex;
    align-items: center;
    margin: 0;
}

.usage-page .card-body {
    padding: 1.5rem;
}

/* Pricing Info Card */
.pricing-info-card {
    border: 2px solid #2962ff;
    background: linear-gradient(135deg, rgba(41, 98, 255, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
}

.pricing-info-card h5 {
    color: #2962ff;
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.pricing-info-card p {
    color: #6c757d;
    line-height: 1.6;
}

.price-highlight {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.price-amount {
    font-size: 2.5rem;
    font-weight: 700;
    color: #2962ff;
    line-height: 1;
}

.price-label {
    font-size: 0.9rem;
    color: #6c757d;
    font-weight: 500;
    margin-top: 0.5rem;
}

/* Responsive */
@media (max-width: 768px) {
    .usage-page {
        padding: 10px;
    }

    .stat-card .card-body {
        padding: 1rem;
    }

    .stat-icon {
        width: 48px;
        height: 48px;
    }

    .stat-value {
        font-size: 1.5rem;
    }

    .price-amount {
        font-size: 2rem;
    }

    .page-title {
        font-size: 1.5rem;
    }
}

/* Chart Containers */
.usage-page .card-body canvas {
    max-height: 300px;
}

/* Loading and Error States */
.usage-page .text-center {
    padding: 3rem 0;
}

.usage-page .spinner-border {
    width: 3rem;
    height: 3rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Usage.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;AAChB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;AAChB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;AAChB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;AAChB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,UAAU;AACV;IACI,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,uCAAuC;IACvC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,yBAAyB;IACzB,8FAA8F;AAClG;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,qBAAqB;AACrB;IACI,iBAAiB;AACrB;;AAEA,6BAA6B;AAC7B;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":["/* Usage Page Styles */\n.usage-page {\n    padding: 20px;\n}\n\n.page-title {\n    display: flex;\n    align-items: center;\n    font-weight: 600;\n    color: #2c3e50;\n    margin-bottom: 0;\n}\n\n/* Trial Alert */\n.trial-alert {\n    border-left: 4px solid #28a745;\n    background-color: #d4edda;\n    border-radius: 8px;\n}\n\n.trial-alert h5 {\n    color: #155724;\n    margin-bottom: 0.5rem;\n}\n\n.trial-alert p {\n    color: #155724;\n    font-size: 0.95rem;\n}\n\n/* Stat Cards */\n.stat-card {\n    border: none;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n    transition: transform 0.2s, box-shadow 0.2s;\n    height: 100%;\n}\n\n.stat-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n}\n\n.stat-card .card-body {\n    padding: 1.5rem;\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.stat-icon {\n    width: 60px;\n    height: 60px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.stat-icon.trips {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n}\n\n.stat-icon.amount {\n    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n    color: white;\n}\n\n.stat-icon.price {\n    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n    color: white;\n}\n\n.stat-icon.status {\n    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);\n    color: white;\n}\n\n.stat-content {\n    flex: 1;\n}\n\n.stat-label {\n    font-size: 0.85rem;\n    color: #6c757d;\n    margin-bottom: 0.5rem;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.stat-value {\n    font-size: 1.8rem;\n    font-weight: 700;\n    color: #2c3e50;\n    margin: 0;\n    line-height: 1;\n}\n\n/* Billing Detail Items */\n.billing-detail-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.75rem 0;\n}\n\n.billing-detail-item .label {\n    color: #6c757d;\n    font-weight: 500;\n}\n\n.billing-detail-item .value {\n    color: #2c3e50;\n    font-weight: 600;\n}\n\n.billing-detail-item.total {\n    padding-top: 1rem;\n    border-top: 2px solid #dee2e6;\n}\n\n.billing-detail-item.total .label {\n    color: #2c3e50;\n    font-size: 1.1rem;\n}\n\n.billing-detail-item.total .value {\n    color: #2962ff;\n    font-size: 1.2rem;\n}\n\n/* Cards */\n.usage-page .card {\n    border: none;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n    margin-bottom: 1.5rem;\n}\n\n.usage-page .card-header {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border: none;\n    border-radius: 12px 12px 0 0 !important;\n    padding: 1rem 1.5rem;\n}\n\n.usage-page .card-header h5 {\n    display: flex;\n    align-items: center;\n    margin: 0;\n}\n\n.usage-page .card-body {\n    padding: 1.5rem;\n}\n\n/* Pricing Info Card */\n.pricing-info-card {\n    border: 2px solid #2962ff;\n    background: linear-gradient(135deg, rgba(41, 98, 255, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);\n}\n\n.pricing-info-card h5 {\n    color: #2962ff;\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n}\n\n.pricing-info-card p {\n    color: #6c757d;\n    line-height: 1.6;\n}\n\n.price-highlight {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.price-amount {\n    font-size: 2.5rem;\n    font-weight: 700;\n    color: #2962ff;\n    line-height: 1;\n}\n\n.price-label {\n    font-size: 0.9rem;\n    color: #6c757d;\n    font-weight: 500;\n    margin-top: 0.5rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .usage-page {\n        padding: 10px;\n    }\n\n    .stat-card .card-body {\n        padding: 1rem;\n    }\n\n    .stat-icon {\n        width: 48px;\n        height: 48px;\n    }\n\n    .stat-value {\n        font-size: 1.5rem;\n    }\n\n    .price-amount {\n        font-size: 2rem;\n    }\n\n    .page-title {\n        font-size: 1.5rem;\n    }\n}\n\n/* Chart Containers */\n.usage-page .card-body canvas {\n    max-height: 300px;\n}\n\n/* Loading and Error States */\n.usage-page .text-center {\n    padding: 3rem 0;\n}\n\n.usage-page .spinner-border {\n    width: 3rem;\n    height: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
